export const MAX_PASSENGERS = 8
export const MAX_ROOMS = 4
export const MIN_ADULTS = 1
export const MIN_CHILDREN = 0
export const MIN_ROOMS = 1
export const TRAVELER_SELECTION_CONTAINER_MAX_WIDTH = 768

export const labels = {
  ADULTS: 'Adults',
  CHILDREN: 'Children',
  INFANTS: 'Lap Infants',
  ROOMS: 'Rooms',
  YOUTHS: 'Youths'
}

export const subLabels = {
  ADULTS: '',
  CHILDREN: '(ages 2-14)',
  INFANTS: '(under 2)',
  ROOMS: '',
  YOUTHS: '(ages 15-17)'
}

export const VP_DISCLAIMER =
  'You may only book a package for up to 8 travelers.'

export const FLIGHTS_DISCLAIMER =
  'You may only book a flight for up to 8 travelers.'
